export const frontmatter = {
    "draft": true,
    "title": "Integraciones",
    "sidebar_group": "guías",
    "sidebar_label": "Integraciones",
    "sidebar_order": 1
}

export const toc = []